import { render, staticRenderFns } from "./editDataUser.vue?vue&type=template&id=d1c773a2&"
import script from "./editDataUser.vue?vue&type=script&lang=js&"
export * from "./editDataUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports